import React from "react";
import classes from "./WelcomingWindow.module.css";
import rocketImage from "../../public/studioErstellen/welcomePage/rocketImage.png"
import coinImage from "../../public/studioErstellen/welcomePage/coinImage.png"
import percentageImage from "../../public/studioErstellen/welcomePage/percentageImage.png"

export const WelcomingWindow = () => {

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <h1 className={classes.title}>Sichere dir exklusive Vorteile!</h1>
        <span>Inseriere dein Studio noch vor dem Release und sichere dir:</span>
      </header>
      <div className={classes.mainContent}>
        <div className={classes.contentItem}>
          <div className={classes.textContainer}>
            <h2 className="titleSemibold3">Mehr Sichtbarkeit</h2>
            <p className={classes.text}>
              Als Stu Original wirst du weiter oben gelistet!
            </p>
          </div>
          <div className={classes.imageContainer}>
            <img src={rocketImage} alt="Mehr Sichtbarkeit" />
          </div>
        </div>
        <div className={classes.contentItem}>
          <div className={classes.textContainer}>
            <h2 className="titleSemibold3">Ein exklusives Badge</h2>
            <p className={classes.text}>
              Für alle, die von Anfang an dabei sind!
            </p>
          </div>
          <div className={classes.imageContainer}>
            <img src={coinImage} alt="Mehr Sichtbarkeit" />
          </div>
        </div>
        <div className={classes.contentItem}>
          <div className={classes.textContainer}>
            <h2 className="titleSemibold3">Reduzierte Gebühren</h2>
            <p className={classes.text}>
            Im Soft Launch zahlst du 0% Provisionsgebühren!
            </p>
          </div>
          <div className={classes.imageContainer}>
            <img src={percentageImage} alt="Mehr Sichtbarkeit" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomingWindow;
